import React from 'react';
import { CREATE_ORDER_ADDITIONAL_INFORMATION_TEXT_ID, NO_DATA_FALLBACK } from '../../../configuration';
import { convertSapToHtmlLinebreaks } from '../../../utilities';
import { IPostCreateOrderResponseData } from '../../../actions/post-create-order.action';
import { ILxsCreateOrderResources } from '../lxs-create-order.props.autogenerated';

export const OrderInfo = ({
    resources,
    orderData: { Order }
}: {
    orderData: IPostCreateOrderResponseData;
    resources: ILxsCreateOrderResources;
}) => {
    return (
        <div className='msc-section-box'>
            <h4 className='msc-section-box__title'>{resources.createOrderGeneralOrderHeading}</h4>
            <div className='row lxs-create-order__order-info'>
                <div className='col-md-3'>
                    <label>{resources.createOrderOrderNumberLabel}</label>
                    <p>{Order.OrderNumber ? Order.OrderNumber : NO_DATA_FALLBACK}</p>
                </div>
                <div className='col-md-3'>
                    <label>{resources.createOrderCustomerPoLabel}</label>
                    <p>{Order.PurchaseOrderNumbExt ? Order.PurchaseOrderNumbExt : NO_DATA_FALLBACK}</p>
                </div>
                <div className='col-md-3'>
                    <label>{resources.createOrderOrderTypeLabel}</label>
                    <p>{Order.OrderType ? Order.OrderType : NO_DATA_FALLBACK}</p>
                </div>
                <div className='col-md-3'>
                    <label>{resources.createOrderIncoterms1Label}</label>
                    <p>{Order.Incoterm1 ? Order.Incoterm1 : NO_DATA_FALLBACK}</p>
                </div>
            </div>
            <div className='row'>
                <div className='col-12'>
                    <label>{resources.createOrderAdditionalInfoLabel}</label>
                    {Order.HeaderTexts?.find(text => text.TextId === CREATE_ORDER_ADDITIONAL_INFORMATION_TEXT_ID)?.Value ? (
                        <p
                            className='lxs-create-order__text-auto-hyphens'
                            dangerouslySetInnerHTML={{
                                __html: convertSapToHtmlLinebreaks(
                                    Order.HeaderTexts?.find(text => text.TextId === CREATE_ORDER_ADDITIONAL_INFORMATION_TEXT_ID)?.Value ??
                                        ''
                                )
                            }}
                        ></p>
                    ) : (
                        <p>{NO_DATA_FALLBACK}</p>
                    )}
                </div>
            </div>
        </div>
    );
};
